import { component } from 'picoapp';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default component(async (node) => {
  gsap.registerPlugin(ScrollTrigger);

  const container = node.querySelector<HTMLElement>('[data-container]');

  const init = () => {
    gsap.to(container, {
      x: () => `-${container.scrollWidth - document.documentElement.clientWidth}px`,
      ease: 'none',
      scrollTrigger: {
        trigger: node,
        start: 'top top',
        pin: true,
        scrub: true,
        end: () => {
          if (window.innerWidth < 768) {
            return `+=${container.offsetWidth * 2.5}`;
          }

          return `+=${container.offsetWidth}`;
        },
      }
    });
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        init();
        observer.disconnect();
      }
    });
  });

  observer.observe(node);
});
